<script setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useBasicosFinanceiro } from '@/modules/financeiro/composables/useFinanceiroApi';

const props = defineProps({
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
        default: null
    }
})

const emit = defineEmits(['update:modelValue', 'change']);

const { listaTiposSolicitacoesFinanceiro, carregarTiposSolicitacoesFinanceiro } = useBasicosFinanceiro();


const options = computed(() => {
    return listaTiposSolicitacoesFinanceiro.value
});

const tipoSelecionado = ref();


watch(
    () => tipoSelecionado.value,
    (newValue) => {
        emit('update:modelValue', newValue?.id);
    }
);

onMounted(async () => {
    await carregarTiposSolicitacoesFinanceiro();
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle titulo="Tipo de Solicitação" :obrigatorio="true" />
        <Dropdown :options="options" v-model="tipoSelecionado" optionLabel="nome"
            emptyFilterMessage="Nenhum tipo de solicitação encontrada" :class="{ 'p-invalid': props.erro }"
            placeholder="Selecione o tipo de solicitação" :showClear="true">
        </Dropdown>
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>